export const ACCESS_LEVEL = {
  VIEWER: 1,
  ANALYST: 2,
  ADMIN: 3,
  DEV: 4,
};
